import React, { useState } from "react";
import { filter, toUpper } from "lodash";
import { sentenceCase } from "change-case";
import { makeStyles } from "@material-ui/styles";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { LoadingButton } from "@material-ui/lab";
import DownloadIcon from "@material-ui/icons/Download";
import * as locales from "@material-ui/core/locale";
import { useSnackbar } from "notistack";
import { descargarPdfDteProxy } from "../../utils/sharedFunctions";
import { useDescargarPdfDteMutation } from "../../services/dteApi";
// material
import {
  Button,
  Card,
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { TablaHead, TablaToolbar } from "../_dashboard/tablas";
import Label from "../Label";
import Scrollbar from "../Scrollbar";
import SearchNotFound from "../SearchNotFound";
import PagosFacturas from "./PagosFacturas";
import { facturasApi } from "src/services/facturasApi";

const TABLE_HEAD = [
  { id: "nombre", label: "Cliente", alignRight: false },
  { id: "nombreTarea", label: "Nombre Tarea", alignRight: false },
  { id: "folio", label: "Folio (*)", alignRight: false },
  { id: "valorTarea", label: "Valor Tarea", alignRight: false },
  { id: "descuento", label: "Descuento", alignRight: false },
  { id: "total", label: "Total ($)", alignRight: false },
  { id: "estadoFactura", label: "Estado Facturación (*)", alignRight: false },
  { id: "fechaFacturacion", label: "Fecha Facturación", alignRight: false },

  { id: "estadoCorreo", label: "Estado Correo (*)", alignRight: false },

  { id: "fechaCorreo", label: "Fecha Envio Correo", alignRight: false },
  {
    id: "empleadoEnviaCorreo",
    label: "Empleado Envia Correo",
    alignRight: false,
  },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => {
      return (
        _user.nombreTarea.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.nombreCliente.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.folio.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.total.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.fechaFacturacion.toLowerCase().indexOf(query.toLowerCase()) !==
          -1 ||
        _user.fechaCorreo.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.empleadoEnviaCorreo.toLowerCase().indexOf(query.toLowerCase()) !==
          -1 ||
        _user.estadoCorreo.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.estadoFactura.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.valorTarea.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.tipoMoneda.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.descuento.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    });
  }
  return stabilizedThis.map((el) => el[0]);
}

const styles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginTop: 20,
  },
}));

export default function FacturaTareasEmpleado(props) {
  const { valueFactura, empleado } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [descargarPdf] = useDescargarPdfDteMutation();
  const [locale] = useState("esES");
  const classes = styles();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("nombreTarea");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loadingDescargar, setLoadingDescargar] = useState(false);
  const [openPagos, setOpenPagos] = useState(false);
  const [idFactura, setIdFactura] = useState("");
  const { currentData: facturas = [], isLoading: loadingTable } =
    facturasApi.useGetFacturasTareasEmpleadoQuery(empleado.rut);

  // Descarga el PDF por el proxy backend (la apikey vive solo en el backend).
  const descargarFactura = async (id, token, folio) => {
    if (!token) {
      enqueueSnackbar("No hay archivos que descargar", { variant: "warning" });
      return;
    }
    setLoadingDescargar(true);
    try {
      await descargarPdfDteProxy({
        trigger: descargarPdf,
        tipo: "tarea",
        id,
        nombreArchivo: `${folio}.pdf`,
        enqueueSnackbar,
      });
    } finally {
      setLoadingDescargar(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = facturas.map((n) => n.nombreTarea);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  function formatNumber(n) {
    n = n > 0 ? String(n).replace(/\D/g, "") : n;
    return n === "" ? n : Number(n).toLocaleString("es-CL");
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - facturas.length) : 0;

  const filteredUsers = applySortFilter(
    facturas,
    getComparator(order, orderBy),
    filterName,
  );

  const isUserNotFound = filteredUsers.length === 0;

  const mostrarPagosFactura = (id) => {
    setOpenPagos(true);
    setIdFactura(id);
  };

  return (
    <>
      {valueFactura === 1 && (
        <Card>
          <Typography variant="h5" component="h2" className={classes.title}>
            Facturas del Empleado
          </Typography>
          <Grid
            container
            style={{ padding: "1rem 1.5rem 0rem 1.5rem" }}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} md={3}>
              <TablaToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />
            </Grid>
          </Grid>
          <Scrollbar>
            <TableContainer>
              {!loadingTable ? (
                <Table>
                  <TablaHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={facturas.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row) => {
                        const {
                          id,
                          nombreTarea,
                          nombreCliente,
                          folio,
                          total,
                          fechaFacturacion,
                          fechaCorreo,
                          empleadoEnviaCorreo,
                          estadoCorreo,
                          estadoFactura,
                          valorTarea,
                          tipoMoneda,
                          descuento,
                          token,
                        } = row;
                        const isItemSelected =
                          selected.indexOf(nombreTarea) !== -1;

                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell align="left">
                              <Typography variant="subtitle2">
                                {nombreCliente}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">{nombreTarea}</TableCell>
                            <TableCell align="left">
                              <Button color="primary" disabled={true}>
                                {" "}
                                {folio ? folio : 0}
                              </Button>
                            </TableCell>
                            <TableCell align="left">
                              {tipoMoneda === "PESOS"
                                ? "$" + formatNumber(valorTarea)
                                : formatNumber(valorTarea) +
                                  " " +
                                  toUpper(tipoMoneda)}
                            </TableCell>
                            <TableCell align="left">
                              {descuento + "%"}
                            </TableCell>
                            <TableCell align="left">
                              {formatNumber(total)}
                            </TableCell>
                            <TableCell align="left">
                              <Button disabled={true}>
                                <Label
                                  variant="ghost"
                                  color={
                                    estadoFactura === "FACTURADO"
                                      ? "success"
                                      : estadoFactura === "PAGADO"
                                        ? "info"
                                        : "error"
                                  }
                                >
                                  {sentenceCase(estadoFactura)}
                                </Label>
                              </Button>
                            </TableCell>

                            <TableCell align="left">
                              {fechaFacturacion}
                            </TableCell>
                            <TableCell align="left">
                              <Button disabled={true}>
                                {" "}
                                <Label
                                  variant="ghost"
                                  color={
                                    (estadoCorreo === "ENVIADO" && "success") ||
                                    "error"
                                  }
                                >
                                  {sentenceCase(estadoCorreo)}
                                </Label>
                              </Button>
                            </TableCell>
                            <TableCell align="left">{fechaCorreo}</TableCell>
                            <TableCell align="left">
                              {empleadoEnviaCorreo}
                            </TableCell>
                            <TableCell align="center">
                              <LoadingButton
                                color="primary"
                                loading={loadingDescargar}
                                onClick={() =>
                                  descargarFactura(id, token, folio)
                                }
                              >
                                <DownloadIcon />
                              </LoadingButton>
                              <Button onClick={() => mostrarPagosFactura(id)}>
                                Ver Pagos
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                          <SearchNotFound
                            searchFilter={true}
                            searchQuery={filterName}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              ) : (
                <Skeleton variant="rectangular" width="100%" height="500px" />
              )}
            </TableContainer>
          </Scrollbar>

          <ThemeProvider
            theme={(outerTheme) => createTheme(outerTheme, locales[locale])}
          >
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={facturas.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </ThemeProvider>
        </Card>
      )}
      {openPagos && valueFactura === 1 && (
        <PagosFacturas
          idFactura={idFactura}
          openPagos={openPagos}
          setOpenPagos={setOpenPagos}
          tipoFactura="Tareas"
        />
      )}
    </>
  );
}
